import React from 'react';
import WideP from 'components/common/WideP';
import cn from 'classnames';

function insertBR(str) {
  if (!str) return;
  const arr = str && str.split('\n');
  if (arr && arr.length > 1) {
    return arr.map((s,i) => <span key={i}>{s}<br/></span>); // TODO make HOC ?
  } else {
    return str;
  }
}

const Section = ({ name, title, description, isDark, isFull, style, className, children }) => {
  if (description) {
    description = (
      <div className="container">
        <div className="row no-gutters">
          <div className="col-md-6 offset-md-3">
            <WideP className="ml-auto mr-auto text-center">{insertBR(description)}</WideP>
          </div>
        </div>
      </div>
    );
  }

  return (
    <section id={name} className={cn({ container: !isFull, 'bg-inverse': isDark }, className)} style={style}>
      { title ? <h2 className="text-center">{title}</h2> : undefined }
      { description }
      { children }
    </section>
  )
};

export default Section;


// WEBPACK FOOTER //
// ./src/components/Section.js